<section modalContainer invisibleWhitespace>
    <app-modal-header header (close)="close()">부모님 앱 공유</app-modal-header>
    <div class="flex flex-col w-[31.25rem] gap-3">
        @for (parent of parents(); track $index) {
            <app-document-share-parent-item
                [firstCounseling]="firstCounseling()!"
                [report]="report()!"
                [endReport]="endReport()!"
                [parent]="parent"
                (refresh)="refresh()"
                (output)="handleOutput($event)"
            />
        } @empty {
            <div
                class="min-h-[20rem] flex flex-col items-center justify-center gap-3"
            >
                <app-icon
                    name="material-symbols:unknown-document-sharp"
                    class="text-gray-400"
                />
                <p class="text-gray-500">아동에게 등록된 보호자가 없습니다.</p>
            </div>
        }
    </div>
    <div
        footer
        class="flex w-full justify-between gap-3 items-center p-4 border-t border-gray-100"
    >
        <app-button
            (click)="allCancel()"
            color="gray"
            variant="outline"
            icon="material-symbols:cancel-schedule-send"
            >전체 중지</app-button
        >
        <app-button (click)="submit()">저장</app-button>
    </div>
</section>
